import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateSettingsPage,
  getSettingsListAll,
} from "../../../redux/settings/action";
import { useFormik } from "formik";
import Spinner from "../../Layouts/Spinner";
import { termsAndConditionValidation } from "../../Constant/constant";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const TermsandCondition = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [editorData, setEditorData] = useState('');
  const [editorData1, setEditorData1] = useState('');

  const settingsListData = useSelector(
    (state) => state?.reusableSlice?.settingsListData
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      terms: settingsListData?.terms || "",
      ar_terms: settingsListData?.ar_terms || "",
    },
    validationSchema: termsAndConditionValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      id: settingsListData.id,
    };
    dispatch(UpdateSettingsPage(data, setLoading));
  };

  useEffect(() => {
    dispatch(getSettingsListAll());
  }, [dispatch]);

  const handleEditorChange = (content) => {
    setEditorData(content);
    formik.setFieldValue("terms", content)
  };
  const handleEditorChange1 = (content1) => {
    setEditorData1(content1);
    formik.setFieldValue("ar_terms", content1)
  };

  return (
    <div className="">
      <h3 className="pb-3">Terms and Conditions</h3>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Terns and Conditions </label>
            <ReactQuill
              style={{width: "100%" }}
              value={formik.values.terms}
              onChange={handleEditorChange}
            />
            {formik.touched.terms && formik.errors.mobile ? (
              <div className="error">{formik.errors.mobile}</div>
            ) : null}
          </div>

          <div className="form-group col-md-6">
            <label >Terns and Conditions Arabic</label>
            <ReactQuill
              style={{width: "100%" }}
              value={formik.values.ar_terms} onChange={handleEditorChange1}
            />
            {formik.touched.ar_terms && formik.errors.email ? (
              <div className="error">{formik.errors.email}</div>
            ) : null}
          </div>
        </div>
        <button
          className="submit-btn d-block mx-auto mt-9"
          style={{ width: "max-content" }}
          type="submit"
        >
          {!loading ? "Submit" : <Spinner />}
        </button>
      </form>
    </div>
  );
};

export default TermsandCondition;
